<!-- <template>
  <div>
    <trade-response-info></trade-response-info>
  </div>
</template> -->

<template>
  <div>
    <v-card>
      <!-- <v-card-title> -->
      <v-row class="pa-5">
        <v-col cols="10" class="float-right text-right">
          <v-tabs v-model="tab" show-arrows>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#InfoDetail">
              <h6>جزئیات</h6>
            </v-tab>
            <v-tab
              href="#Message"
              v-if=" selectedTrade &&
                selectedTrade.request == 'DirectOrder'
              "
            >
              <h6>گفتگو با خریدار</h6>
            </v-tab>
            <!-- <v-tab href="#Event">
              <h6>سوابق اقدام</h6>
            </v-tab> -->
          </v-tabs>
        </v-col>
        <v-col cols="2" class="float-left text-left">
          <v-btn color="error" @click="closeForm()" icon>
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item :value="'InfoDetail'">
          <v-card-text flat>
            <div>
              <trade-response-info></trade-response-info>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Message'">
          <ThreadsList
            @getConversationId="getConversationId"
            @closeThreadList="null"
            topic="TradeResponse"
            type="MerchantMerchant"
            :key="key"
            :objectId="id"
            :conversationId="
              directOrderConversationList && directOrderConversationList.length
                ? directOrderConversationList[0].conversationId
                : null
            "
            :recipientMerchantId="selectedTrade.merchantId"
            :recipientUserId="null"
            :createdByMerchantId="merchantId ? merchantId : null"
              :isUserBase="false"
            >
          </ThreadsList>
          <!-- <ConversationList></ConversationList> -->
        </v-tab-item>
        <!-- <v-tab-item :value="'Event'">
          <v-card-text flat>
            <trade-request-events></trade-request-events>
          </v-card-text>
        </v-tab-item> -->
      </v-tabs-items>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>
<script>
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
import ThreadsList from '@/components/core/conversation/components/ThreadsList.vue';
import TradeResponseInfo from '../components/TradeResponseInfo.vue';
const conversationRepository = () => RepoFactory.get('conversation');
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  data() {
    return {
      key: 0,
      directOrderConversationList: null,
      tradeRequestId: null,
      OrdererMerchantId: null,
      selectedTrade: null,
    };
  },
  components: {
    TradeResponseInfo,
    ThreadsList,
  },
  // props: {
  //   OrdererMerchantId: {
  //     type: String,
  //     default: '',
  //   },
  // },
 
  methods: {
    closeForm() {
      this.$router.push({ path: `/trade-response` });
      // this.$router.push({ path: '/trade-request-direct' });
    },
    getConversationId(val) {
      this.directOrderConversationList[0].conversationId = val;
      this.key += 1;
    },
    getdirectOrderConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.tradeRequestId,
        type: 'MerchantMerchant',
        topic: 'TradeResponse',
        PageNumber: 1,
        ItemsPerPage: 5,
      };
      conversationRepository()
        .getConversation(
          this.contentBaseUrl,
          { MerchantId: this.merchantId },
          param
        )
        .then((res) => {
          this.directOrderConversationList = res.data.list;
        })
        .catch((err) => {
          console.log('err', err);
        })
        .finally(() => loader.hide());
    },

    getData( ) {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeRequsetByIdForResponse(this.id, this.baseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          loader.hide();

          this.selectedTrade = res.data;

          console.log('this.selectedTrade');
          console.lof( res.data)
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
  },

  computed: {
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    // supplierId() {
    //   return this.$store.getters.tradeRequestSelectedItem?.supplierId;
    // },
  },
  created() {
    this.tradeRequestId = this.$route.params.id;
    if (this.tradeRequestId) {
      this.getdirectOrderConversaion();
      // this.OrdererMerchantId = this.$store.getters.tradeResponseProp.tradeRequestOwnerMerchantId;
      // this.id = this.$route.params.id;

      this.OrdererMerchantId = this.tradeRequestId;
      if (this.merchantId) {
         this.getData();
      }
     // this.getData(this.$store.getters.currentMerchant);
    }
  },
   watch: {
   
     merchantId(value) {
     
      if (value.length ) {
        this.getData();
      }
    },
    
  },
};
</script>

<style></style>
